// extracted by mini-css-extract-plugin
module.exports = {"link":"BreadcrumbNav_link__3B-pw","active":"BreadcrumbNav_active__3WFMj","separator":"BreadcrumbNav_separator__3dLZn"};